import React from "react";
import { CompositionDetail, SelectedDataset, Dataset } from "../CompositionDetail";

interface CompositionBuildProps {
  availableDatasets: Dataset[];
  selectedDatasets: SelectedDataset[];
  datasetsLoading: boolean;
  onAddDataset: (dataset: Dataset) => void;
  onRemoveDataset: (datasetId: number) => void;
  onConfigureDataset: (dataset: SelectedDataset) => void;
}

const CompositionBuild: React.FC<CompositionBuildProps> = ({
  availableDatasets,
  selectedDatasets,
  datasetsLoading,
  onAddDataset,
  onRemoveDataset,
  onConfigureDataset,
}) => {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center space-y-3">
        <h2 className="text-2xl font-gc-demi-bold text-foreground">
          Build Your Composition
        </h2>
        <p className="text-muted-foreground font-gc-reg">
          Select and configure datasets to include in your composition. You can adjust sampling methods and distribution percentages.
        </p>
      </div>

      <CompositionDetail
        availableDatasets={availableDatasets}
        selectedDatasets={selectedDatasets}
        datasetsLoading={datasetsLoading}
        onAddDataset={onAddDataset}
        onRemoveDataset={onRemoveDataset}
        onConfigureDataset={onConfigureDataset}
      />
    </div>
  );
};

export default CompositionBuild; 